import { FiltersViewModel } from '../infra/FiltersViewModel'
import { SearchTextViewModel } from '../infra/SearchTextViewModel'
import InfiniteScrollProvider from '../utils/InfiniteScrollProvider'
import SearchableUserStore from '../iam/SearchableUserStore'
import { combineLatest, Subscription } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { computed, makeObservable } from 'mobx'

export class UserSearchViewModel {
  private subscription = new Subscription()

  searchText = new SearchTextViewModel(500)

  filters = new FiltersViewModel({
    definitions: {},
  })

  private query$ = combineLatest([
    this.filters.appliedFilters$,
    this.searchText.debouncedValue$,
  ]).pipe(switchMap(() => this.scrollProvider.fetch()))

  scrollProvider = new InfiniteScrollProvider({
    limit: 100,
    startFetchTaskAsPending: true,
    fetchItems: (paging, _) =>
      this.store.fetchUsers({
        search_text: this.searchText.value,
        limit: paging.limit,
        after: paging.after,
      }),
  })

  constructor(private store: SearchableUserStore) {
    makeObservable(this)
  }

  @computed
  get total() {
    return this.scrollProvider.items.length
  }

  activate() {
    this.filters.activate()
    this.scrollProvider.fetch()
    this.subscription = this.query$.subscribe()
  }

  deactivate() {
    this.filters.deactivate()
    this.subscription.unsubscribe()
  }
}
